import { render, staticRenderFns } from "./StudentDetail.vue?vue&type=template&id=8deb39f0&scoped=true"
import script from "./StudentDetail.vue?vue&type=script&lang=ts"
export * from "./StudentDetail.vue?vue&type=script&lang=ts"
import style0 from "./StudentDetail.vue?vue&type=style&index=0&id=8deb39f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8deb39f0",
  null
  
)

export default component.exports